// extracted by mini-css-extract-plugin
module.exports = {"page":"Page_page__3m1mN","shadow":"Page_shadow__231Fw"};